import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UtilityServiceService } from "app/services/utility-service.service";
import { AdminAnnualComplianceListFilterConfig } from "app/shared/filter/filter.constant";
import { AdminAnnualComplianceService } from "../service/admin-annual-compliance.service";
import { AuthWebService } from 'app/services/authweb.service';

@Component({
  selector: "app-admin-annual-compliance-list",
  templateUrl: "./admin-annual-compliance-list.component.html",
  styleUrls: ["./admin-annual-compliance-list.component.scss"],
})
export class AdminAnnualComplianceListComponent implements OnInit {
  filterConfig = AdminAnnualComplianceListFilterConfig;
  isEmpty: boolean = false;
  pTypes: any = [];
  total: number = 0;
  isLoading: boolean = false;
  direction = false;
  carrierNumber: string;
  carrierName: string;
  annualComplianceListData: any = [];
  keyword: any = {};
  rankCtrl: number = 1;
  pageSize: number = 10;
  PermitNumber: any;
  PermitType: number;
  Carrier: any;
  FirstOrDuplicate: boolean;
  VehicleRegistrationNumber: any;
  date_to: any;
  Statuses: any;
  selectedItems: any = [];
  types;
  count: number = 0;
  statuses: any = [];
  currentPage = 1;

  constructor(
    private _router: Router,
    public utility: UtilityServiceService,
    private _service: AdminAnnualComplianceService, private authWebService: AuthWebService ,private router: Router 
  ) {}

  ngOnInit(): void {

    if (this.authWebService.userData.Roles[0].IsExternalRole) {
      this.router.navigate(['/home']); // Replace '/unauthorized' with the route you want to navigate when access is denied.
    }

    this.utility.page = 1;
    this.getListData();
  }
  onViewPermit(data) {
    console.log("whats in data",data);
    this._router.navigate([`/carrier/permit/application/annual/view/${data.id}`]);
  }
  onViewDetails(data) {
    this._router.navigate([`/admin-annual-compliance/details/${data.id}`]);
  }

  onViewApplication(data) {
    this._router.navigate([`/admin-annual-compliance/application/${data.id}`]);
  }

  getListData() {
    this.isLoading = true;
    this._service
      .getAdminAnnualCompList(this.currentPage, this.pageSize)
      .subscribe(
        (result: any) => {
          this.annualComplianceListData = result?.m_Item1;
          this.count = result?.m_Item2;
          this.utility.onSort(1);
          this.isLoading = false;
          this.isEmpty = false;
        },
        (error) => {
          this.isEmpty = true;
          this.isLoading = false;
        }
      );
  }

  resetPages() {
    this.pageSize = 10;
    this.currentPage = 1;
  }
  applyFilter(filters) {
    this.resetPages();
    if (!filters) {
      this.keyword = {};
      this.getListData();
    } else {
      this.selectedItems = filters?.Statuses;

      (this.keyword.PermitType = filters?.PermitType
        ? filters?.PermitType
        : ""),
        (this.keyword.PermitNumber = filters?.PermitNumber
          ? filters.PermitNumber
          : ""),
        (this.keyword.Carrier = filters?.Carrier ? filters?.Carrier : ""),
        (this.keyword.FirstOrDuplicate =
          filters?.FirstOrDuplicate === "true"
            ? true
            : filters?.FirstOrDuplicate === "false"
            ? false
            : "");
      (this.keyword.VehicleRegistrationNumber =
        filters?.VehicleRegistrationNumber
          ? filters?.VehicleRegistrationNumber
          : ""),
        (this.keyword.Statuses = this.selectedItems
          ? this.selectedItems.map((status) => {
              return status.id;
            })
          : []);
      if (filters) {
        this.getFilterResponse();
      } else {
        this.getListData();
      }
    }
  }

  getFilterResponse() {
    this.isLoading = true;
    this._service
      .getAllByFilter(this.keyword, this.currentPage, this.pageSize)
      .subscribe(
        (result: any) => {
          this.annualComplianceListData = result?.m_Item1;
          this.count = result.m_Item2;
          this.utility.onSort(1);
          this.isLoading = false;
          if (this.annualComplianceListData.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
        },
        (error) => {
          this.annualComplianceListData = [];
          this.isLoading = false;
          this.isEmpty = true;
        }
      );
  }
  onSort(rank: any) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
  }
  onNextOrPrevious(page: number = 1) {
    this.currentPage = page;
    if (Object.keys(this.keyword).length > 0) {
      this.getFilterResponse();
    } else {
      this.getListData();
    }
    return page;
  }

  onChange(event) {
    this.currentPage = 1;
    this.pageSize = event;
    if (Object.keys(this.keyword).length > 0) {
      this.getFilterResponse();
    } else {
      this.getListData();
    }
  }
}
